<template>
    <div>
        <div class="row py-4">
            <div class="col-md-12 text-center" v-show="!permission">
                <div class="p-5">
                    <button type="button" class="btn btn-primary" @click="sendCommand('showLiveView', {}); ping = 0; loadFirstCommand = true">
                        <i class="fas fa-md fa-tv mr-2"></i> Iniciar Visão Remota ...
                    </button>

                    <div v-if="loadFirstCommand && !permission" class="my-4 text-center align-content-center">
                        <div class="mb-3">
                            <i class="fas fa-laptop-house fa-3x"></i>
                        </div>
                        <div class="d-flex align-content-center justify-content-center">
                            <b-spinner class="mr-2 align-self-center"></b-spinner>
                            <span class="align-self-center">
                                Tentando conectar ao player remotamente ...
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mx-auto" v-show="permission">
                <div class="row mb-4">

                    <div class="col-md-7">

                        <div class="btn-group">

                            <button type="button" class="btn btn-primary" @click="sendCommand('backButton', {})">
                                <i class="fas fa-md fa-arrow-left mr-2"></i> Voltar
                            </button>

                            <button type="button" class="btn btn-primary" @click="sendCommand('homeButton', {})">
                                <i class="fas fa-md fa-home mr-2"></i> Home
                            </button>

                            <button type="button" class="btn btn-primary" @click="restartPlayer">
                                <i class="fas fa-md fa-power-off mr-2"></i> Reiniciar
                            </button>

                            <button type="button" class="btn btn-primary" @click="sendCommand('changeOrientation', {})">
                                <i class="fas fa-md fa-undo mr-2"></i> Girar
                            </button>

                            <button type="button" class="btn font-weight-bold" :class="{'btn-success': ping <= 3, 'btn-secondary': (ping > 3 && ping <= 6), 'btn-danger': ping > 6}" v-b-tooltip.hover title="Última Atualização">
                                <i class="fas fa-md fa-clock mr-2"></i> {{ ping }} ms
                            </button>

                        </div>

                    </div>

                    <div class="col-md-5">
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="text" placeholder="Escreva o texto para enviar para o player"/>
                            <div class="input-group-append">
                                <button type="button" class="btn btn-primary" @click="sendCommand('sendTextButton', text)">
                                    <i class="fas fa-md fa-paper-plane mr-2"></i> Enviar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-2">
                    <div class="text-center noselect" style="cursor: pointer" :width="canvasWidth" :height="canvasHeight">
                        <canvas ref="liveView" :width="canvasWidth" :height="canvasHeight" style="position:absolute; z-index:9999"></canvas>
                        <img :src="imageBase64" :width="canvasWidth" :height="canvasHeight" style="position:relative"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['player'],
        data() {
            return {
                channel: null,
                loadCommand: false,
                loadFirstCommand: false,
                permission: false,
                imageBase64: '',
                loading: false,
                isProcessing: false,
                time: null,
                timeCommand: null,
                text: null,
                liveViewCanvas: null,
                liveViewCanvasContext: null,
                canvasWidth: 800,
                canvasHeight: 450,
                mousedown: {},
                ping: 0,
                startTime: Date.now()
            }
        },
        async mounted() {
            this.liveViewCanvas = this.$refs.liveView;
            this.liveViewCanvasContext = this.liveViewCanvas.getContext("2d");
            this.liveViewCanvas.addEventListener('mousedown', (e) => {
                const position = this.getCursorPosition(this.liveViewCanvas, e)
                this.mousedown = {
                    canvasWidth: this.canvasWidth,
                    canvasHeight: this.canvasHeight,
                    ...position
                };
            })
            this.liveViewCanvas.addEventListener('mouseup', (e) => {
                const position = this.getCursorPosition(this.liveViewCanvas, e)
                const data = {
                    canvasWidth: this.canvasWidth,
                    canvasHeight: this.canvasHeight,
                    ...position
                }

                if (this.mousedown) {
                    if(this.mousedown.x === data.x && this.mousedown.y === data.y) {
                        this.sendCommand('tapClick', data);
                    } else {
                        const dataDrag = {
                            start: this.mousedown,
                            end: data
                        }
                        this.sendCommand('tapDrag', dataDrag);
                    }
                }
            });

            // Listen Socket
            this.channel = await Echo.channel('player-' + this.player.code);

            // Subscribe
            await this.channel.subscribe();

            this.channel.listen('.startLive', (e) => {
                this.loadFirstCommand = false;
                this.permission = true;
                this.startTime = Date.now();
                this.ping = 0;
            });

            this.channel.listen('.image', (e) => {
                this.permission = true;
                this.startTime = Date.now();
                this.imageBase64 = e.data;
            });

            this.time = setInterval(() => {
                let elapsedTime = Date.now() - this.startTime;
                this.ping = (elapsedTime / 1000).toFixed(3);
            }, 100)

            this.timeCommand = setInterval(() => {
                if (this.permission) {
                    if (!this.loadCommand) {
                        this.sendCommand("pingConnection")
                    }
                }
            }, 5000)

        },
        beforeDestroy() {
            clearInterval(this.time)
            clearInterval(this.timeCommand)
            Echo.channel('player-' + this.player.code).unsubscribe()
        },
        methods: {
            getCursorPosition(canvas, event) {
                const rect = canvas.getBoundingClientRect()
                const x = event.clientX - rect.left
                const y = event.clientY - rect.top
                console.log("x: " + x + " y: " + y)
                return {x, y};
            },
            restartPlayer() {
                if (confirm('Deseja realmente reiniciar o player ?')) {
                    this.sendCommand('sendRestart', {});
                }
            },
            sendCommand(event, data) {
                let dataPost = {
                    event: event,
                    data: data
                };

                this.loadCommand = true;

                axios.post(this.route('players.liveview.sendCommand', this.player.id).url(), dataPost)
                    .then(result => {
                        if (event !== "pingConnection") {
                            this.$toast.success("O comando foi enviado para o player ...");
                        }
                    })
                    .catch(error => {
                    })
                    .finally(() => this.loadCommand = false)
            }
        }
    }
</script>

<style>
    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }
</style>
